import { atom } from 'jotai';
import { IReconciliationEntity } from 'domains/reconciliation/types/reconciliation.types';

export const reconRecordAtom = atom<null | IReconciliationEntity>(null);
